export const environment = {
    env:"app"
};